







import { Component, Prop, Vue } from 'vue-property-decorator';
import _ from 'lodash';

type ORIENTATION = 'portrait' | 'landscape';

@Component({})
export default class RotateLock extends Vue {
    @Prop( {
        // default: Number.POSITIVE_INFINITY
        default: 1000,
        type: Number
    })
    private maxwidth?: number;

    @Prop( {
        default: "landscape",
        type: String
    })
    private mode?: string;




    private showContent:boolean = false;
    private rotateState:string = "landscape";
    private reSizeDebounceCooldown:number = 300;

    private created () {
        this.updateRotationState();
        this.isContentVisible();
    }

    private updateFunction =  this.updateRotationState;
    mounted() {

        window.addEventListener('orientationchange',() => this.updateFunction());
        window.addEventListener('resize', _.debounce(this.isContentVisible, this.reSizeDebounceCooldown));
        this.isContentVisible();
    }

    destroyed() {
        window.removeEventListener('orientationchange', () => this.updateFunction());
        window.removeEventListener('resize', _.debounce(this.isContentVisible, this.reSizeDebounceCooldown));
    }

    private updateRotationState() {
        this.rotateState = this.getScreenOrientation()
        this.isContentVisible();
    }

    private getScreenOrientation() : ORIENTATION  {
        if (window.screen.orientation && typeof window.screen.orientation.type != 'undefined') {
            return (window.screen.orientation.type as ORIENTATION);
        }else{
            return (this.rotateState = window.orientation == 90 || window.orientation == -90 ? "landscape" : "portrait") as ORIENTATION;
        }
    }


    private isContentVisible() {
        this.showContent =  window.outerWidth > this.$props.maxwidth || this.rotateState.includes(this.mode == null ? "" : this.mode);
    }
}
